class ModalVideo {
    constructor() {
        let modal = document.querySelectorAll(".modal-video-id");
        let iframe = document.querySelectorAll(".modal-video-id iframe");
        let openModals = document.querySelectorAll(".open-modal");
        let closeModal = document.querySelector(".backshadow");
        let closeModalBtn = document.querySelector(".close-modal");
        
        for (let openModal of openModals) {
            openModal.addEventListener('click', function(event) {
                event.preventDefault();
                let videoid = this.dataset.videoid;
                iframe[0].src = 'https://www.youtube.com/embed/'+videoid;
                modal[0].classList.add('show');
            });
        }

        closeModal.addEventListener('click', function(event) {
            event.preventDefault();
            modal[0].classList.remove('show');
            iframe[0].src = '';
        });

        closeModalBtn.addEventListener('click', function(event) {
            event.preventDefault();
            modal[0].classList.remove('show');
            iframe[0].src = '';
        });
    }
}

export default ModalVideo;